/**
 * Categorías de gastos extras — iconos, colores e IDs.
 */
export const CATS_LIST = [
  { id: "Comida",        icon: "🍔", color: "#F97316" },
  { id: "Ropa",          icon: "👗", color: "#EC4899" },
  { id: "Ocio",          icon: "🎮", color: "#8B5CF6" },
  { id: "Salud",         icon: "💊", color: "#10B981" },
  { id: "Viaje",         icon: "✈️",  color: "#3B82F6" },
  { id: "Hogar",         icon: "🏠", color: "#6366F1" },
  { id: "Transporte",    icon: "🚗", color: "#F59E0B" },
  { id: "Educación",     icon: "📚", color: "#14B8A6" },
  { id: "Tecnología",    icon: "💻", color: "#64748B" },
  { id: "Restaurantes",  icon: "🍽️", color: "#EF4444" },
  { id: "Mascotas",      icon: "🐾", color: "#84CC16" },
  { id: "Deporte",       icon: "🏋️", color: "#06B6D4" },
  { id: "Belleza",       icon: "💅", color: "#F43F5E" },
  { id: "Suscripciones", icon: "📱", color: "#A855F7" },
  { id: "Otros",         icon: "📦", color: "#94A3B8" },
];

export const CATS     = CATS_LIST.map((c) => c.id);
export const catIcon  = (id) => CATS_LIST.find((c) => c.id === id)?.icon || "📦";
export const catColor = (id) => CATS_LIST.find((c) => c.id === id)?.color || "#94A3B8";
